import { getNextAvailability } from './actions';

export default {
    getNextAvailability,
};
